module.exports = __webpack_public_path__ + "img/mines.ba0246c8.jpeg";